/**
 * Created by andrey on 01.08.2022
 */

HideAnimations = function (f) {
    const game = Game.currentGame;
    const sceneComponent = ComponentMap.get(this.node, Match3SceneComponent);

    const hideGoals = function (f) {
        if (this.infoPanel) {
            this.infoPanel.hide();
        } else {
            sceneComponent.movesView.hide();
            sceneComponent.goalsView.hide();
        }

        f();
    }.bind(this);

    new ActionPlayer([
        function (f) {
            if (game.outcome !== GameBase.OUTCOME_VICTORY) {
                hideGoals(f);
            } else {
                f();
            }
        },

        function (f) {
            if (sceneComponent.fieldView.visible) {
                game.hideField(f);
            } else {
                f();
            }
        },

        function (f) {
            if (game.hasDanger()) {
                sceneComponent.dangerAnimationView.hide(f);
            } else {
                f();
            }
        },

        function (f) {
            if (game.outcome !== GameBase.OUTCOME_VICTORY) {
                f();
                return;
            }
            sceneComponent.goalsView.animateHighlight(f);
        },

        hideGoals,

        function (f) {
            if (sceneComponent.hardLevelIcon) {
                sceneComponent.hardLevelIcon.hide();
            }

            if (sceneComponent.bonusLevelView) {
                sceneComponent.bonusLevelView.hide(f);
            } else {
                f();
            }
        }
    ]).play(f);
};
